import Repository from './../Repository';

const resource = '/admin/posts';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    update(payload, id) {return Repository.post(`${resource}/${id}`, payload);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
}